/* ============================================================
   Kong — Home Wall of Proof  ·  vanilla JS
   · Reveal on scroll (IntersectionObserver)
   · Carrusel coverflow (clases is-center/is-left/is-right/is-hidden)
   · Lightbox (nav, ESC, click-fuera, swipe)
   · Stats counter (cuenta una vez al entrar en viewport)
   · Swipe táctil en carrusel y lightbox
   · Editor de Shopify (section:load/unload, block:select/deselect)
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* cubic-bezier(0.25,0.1,0.25,1) para el counter */
  function bezier(p1x, p1y, p2x, p2y) {
    function A(a, b) { return 1 - 3 * b + 3 * a; }
    function B(a, b) { return 3 * b - 6 * a; }
    function C(a) { return 3 * a; }
    function calc(t, a) { return ((A(p1x, p2x) * t + B(p1x, p2x)) * t + C(p1x)) * t; } // x only when a=px
    function curveX(t) { return ((A(p1x, p2x) * t + B(p1x, p2x)) * t + C(p1x)) * t; }
    function curveY(t) { return ((A(p1y, p2y) * t + B(p1y, p2y)) * t + C(p1y)) * t; }
    function slopeX(t) { return 3 * A(p1x, p2x) * t * t + 2 * B(p1x, p2x) * t + C(p1x); }
    return function (x) {
      var t = x;
      for (var i = 0; i < 6; i++) { var xx = curveX(t) - x; var d = slopeX(t); if (Math.abs(xx) < 1e-4 || d === 0) break; t -= xx / d; }
      return curveY(t);
    };
  }

  function initSection(root) {
    if (!root || root.dataset.spwInit === '1') return;
    root.dataset.spwInit = '1';

    /* respeta reduced-motion Y el toggle global de animaciones del schema */
    var noMotion = reduce || root.getAttribute('data-anim') === 'false';

    /* ── Reveal ── */
    if (!noMotion && 'IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-inview'); rio.unobserve(root); } });
      }, { threshold: 0.12 });
      rio.observe(root);
    } else { root.classList.add('is-inview'); }

    /* ════ CARRUSEL ════ */
    var stage = root.querySelector('[data-spw-stage]');
    var slides = stage ? Array.prototype.slice.call(stage.querySelectorAll('.spw__slide')) : [];
    var dots = Array.prototype.slice.call(root.querySelectorAll('.spw__dot'));
    var n = slides.length;
    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !noMotion && n > 1;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var timer = null, paused = false;

    function classFor(raw) {
      if (raw === 0) return 'is-center';
      if (raw === -1) return 'is-left';
      if (raw === 1) return 'is-right';
      return 'is-hidden';
    }
    function render() {
      var half = n / 2;
      slides.forEach(function (s, i) {
        var raw = i - current;
        if (raw > half) raw -= n;
        if (raw < -half) raw += n;
        s.classList.remove('is-center', 'is-left', 'is-right', 'is-hidden');
        s.classList.add(classFor(raw));
        s.setAttribute('aria-hidden', raw === 0 ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        var on = i === current;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function go(i) { current = (i % n + n) % n; render(); }

    function start() { stop(); if (autoplay && !paused && n > 1) timer = setInterval(function () { go(current + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    root._spwStop = stop;

    /* oculta el hint "desliza" al primer gesto del usuario */
    function markInteracted() { root.classList.add('spw--swiped'); }

    var prev = root.querySelector('.spw__arrow--prev');
    var next = root.querySelector('.spw__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1); restart(); markInteracted(); });
    if (next) next.addEventListener('click', function () { go(current + 1); restart(); markInteracted(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); markInteracted(); }); });

    /* click en teléfono: central → lightbox · lateral → centrar */
    slides.forEach(function (s, i) {
      var phone = s.querySelector('.spw__phone');
      if (!phone) return;
      phone.addEventListener('click', function () {
        if (i === current) openLightbox(current);
        else { go(i); restart(); markInteracted(); }
      });
    });

    /* teclado en el carrusel */
    root.addEventListener('keydown', function (e) {
      if (root.querySelector('.spw__lb.is-open')) return;       // el lightbox maneja su propio teclado
      if (e.key === 'ArrowLeft') { go(current - 1); restart(); }
      if (e.key === 'ArrowRight') { go(current + 1); restart(); }
    });

    /* pausa hover/focus/pestaña */
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    /* swipe en el carrusel */
    if (stage) addSwipe(stage, function (dir) { go(current + dir); restart(); markInteracted(); });

    /* ════ LIGHTBOX ════ */
    var lb = root.querySelector('[data-spw-lb]');
    var lbImg = lb ? lb.querySelector('.spw__lb-img') : null;
    var lbIndex = 0;
    var images = slides.map(function (s) {
      var im = s.querySelector('.spw__shot');
      return im ? { src: im.getAttribute('data-full') || im.currentSrc || im.src, alt: im.alt } : null;
    });
    var lastFocus = null;

    function showLbImage() {
      var d = images[lbIndex];
      if (d && lbImg) { lbImg.src = d.src; lbImg.alt = d.alt || 'Captura de pantalla'; }
    }
    function openLightbox(i) {
      if (!lb || !images[i]) return;
      lbIndex = i; showLbImage();
      lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      lastFocus = document.activeElement;
      var c = lb.querySelector('.spw__lb-close'); if (c) c.focus();
      stop();
    }
    function closeLightbox() {
      if (!lb) return;
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      start();
    }
    function lbGo(dir) { lbIndex = (lbIndex + dir + images.length) % images.length; showLbImage(); }

    if (lb) {
      var ov = lb.querySelector('.spw__lb-overlay');
      var lbClose = lb.querySelector('.spw__lb-close');
      var lbPrev = lb.querySelector('.spw__lb-prev');
      var lbNext = lb.querySelector('.spw__lb-next');
      if (ov) ov.addEventListener('click', closeLightbox);
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { lbGo(-1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbGo(1); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') lbGo(-1);
        if (e.key === 'ArrowRight') lbGo(1);
      });
      addSwipe(lb.querySelector('.spw__lb-fig') || lb, function (dir) { lbGo(dir); });
    }

    /* ════ STATS COUNTER ════ */
    var nums = Array.prototype.slice.call(root.querySelectorAll('[data-spw-count]'));
    var easing = bezier(0.25, 0.1, 0.25, 1);
    function runCounter(el) {
      var target = parseFloat((el.getAttribute('data-spw-count') || '0').replace(/[^0-9.]/g, '')) || 0;
      var pre = el.getAttribute('data-prefix') || '';
      var suf = el.getAttribute('data-suffix') || '';
      if (noMotion || target === 0) { el.textContent = pre + formatNum(target) + suf; return; }
      var dur = 2000, t0 = null;
      function frame(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var v = Math.round(target * easing(p));
        el.textContent = pre + formatNum(v) + suf;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }
    function formatNum(v) { return v.toLocaleString('es-MX'); }
    if (nums.length) {
      if ('IntersectionObserver' in window) {
        var sio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { runCounter(e.target); sio.unobserve(e.target); } });
        }, { threshold: 0.5 });
        nums.forEach(function (el) { sio.observe(el); });
      } else { nums.forEach(runCounter); }
    }

    /* ════ EDITOR DE SHOPIFY ════ */
    root.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('.spw__slide');
      if (slide) { var idx = slides.indexOf(slide); if (idx >= 0) { go(idx); stop(); } return; }
      var stat = e.target.closest('.spw__stat');
      if (stat) stat.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    root.addEventListener('shopify:block:deselect', function () { start(); });

    render();
    start();
  }

  /* Helper de swipe táctil (sin drag de mouse) */
  function addSwipe(el, onSwipe) {
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) onSwipe(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-spw]');
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-spw]');
    if (root) { root.dataset.spwInit = ''; initSection(root); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-spw]');
    if (root && root._spwStop) root._spwStop();
  });
}());
